import constants from "../config/constants";
import * as timezones from "@/util/timezones.json";
import moment from "moment-timezone";

export default {
    methods: {
        getZoneTemperatureColor: function (zone) {
            if (!zone.power) return "off";

            if (zone.mode === "auto") {
                if (zone.schedule === undefined)
                    zone.schedule = constants.defaultProgram;

                let tz = timezones.default.find(
                    (tz) => tz.value === this.installation.timeZoneId
                );
                if (!tz) {
                    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    timezones.default.every((ti) => {
                        let myUtc = ti.utc.find((utc) => utc === timezone);
                        if (myUtc) {
                            tz = ti;
                            return false;
                        }
                        return true;
                    });
                }
                let date = moment.utc().tz(tz.utc[0]);
                let currentDay = date.day() > 0 ? date.day() - 1 : 6;
                let currentHour = date.hour();

                let scheduleStatus = zone.schedule[currentDay].charAt(currentHour);

                switch (scheduleStatus) {
                    case "O":
                        return zone.ice_mode ? "cold" : "off";
                    case "C":
                        return "warm";
                    case "E":
                        return "eco";
                }
            }

            let iceModeTemp = null;
            switch (zone.type) {
                case constants.zoneTypes.acs:
                    iceModeTemp = constants.acsIceModeTemp;
                    break;

                case constants.zoneTypes.oval_towel:
                case constants.zoneTypes.radiator:
                    iceModeTemp = constants.iceModeTemp;
                    break;
                case constants.zoneTypes.floor:
                    iceModeTemp = -1;
                    break;
                default:
                    iceModeTemp = constants.iceModeTemp;
            }

            let temp = zone.temp;
            if (temp === iceModeTemp) {
                return "cold";
            } else if (zone.type === constants.zoneTypes.acs) {
                if (
                    temp >= constants.acsDefaultEco &&
                    temp < constants.acsDefaultComfort
                )
                    return "eco";
                else if (
                    temp >= constants.acsDefaultComfort &&
                    temp < constants.acsHotTemp
                )
                    return "warm";
                else return "hot";
            } else if (zone.type === constants.zoneTypes.floor) {
                if (temp >= constants.ranges.thermostat.floor.min && temp < 19)
                    return "eco";
                else if (temp >= 19 && temp <= 24) return "warm";
                else return "hot";
            } else {
                if (temp >= constants.defaultEco && temp < constants.defaultComfort)
                    return "eco";
                else if (temp >= constants.defaultComfort && temp < constants.hotTemp)
                    return "warm";
                else return "hot";
            }
        },
        getZoneTemperatureColorBackground: function (zone) {
            if (!zone.power) return "offBackground";

            if (zone.mode === "auto") {
                if (zone.schedule === undefined)
                    zone.schedule = constants.defaultProgram;

                let tz = timezones.default.find(
                    (tz) => tz.value === this.installation.timeZoneId
                );
                if (!tz) {
                    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    timezones.default.every((ti) => {
                        let myUtc = ti.utc.find((utc) => utc === timezone);
                        if (myUtc) {
                            tz = ti;
                            return false;
                        }
                        return true;
                    });
                }
                let date = moment.utc().tz(tz.utc[0]);
                let currentDay = date.day() > 0 ? date.day() - 1 : 6;
                let currentHour = date.hour();
                let scheduleStatus = zone.schedule[currentDay].charAt(currentHour);

                switch (scheduleStatus) {
                    case "O":
                        return zone.ice_mode ? "coldBackground" : "offBackground";
                    case "C":
                        return "warmBackground";
                    case "E":
                        return "ecoBackground";
                }
            }

            let iceModeTemp = null;
            switch (zone.type) {
                case constants.zoneTypes.acs:
                    iceModeTemp = constants.acsIceModeTemp;
                    break;

                case constants.zoneTypes.oval_towel:
                case constants.zoneTypes.radiator:
                    iceModeTemp = constants.iceModeTemp;
                    break;
                case constants.zoneTypes.floor:
                    iceModeTemp = -1;
                    break;
                default:
                    iceModeTemp = constants.iceModeTemp;
            }

            if (!zone.power) return "offBackground";

            let temp = zone.temp;
            if (temp === iceModeTemp) {
                return "coldBackground";
            } else if (zone.type === constants.zoneTypes.acs) {
                if (
                    temp >= constants.acsDefaultEco &&
                    temp < constants.acsDefaultComfort
                )
                    return "ecoBackground";
                else if (
                    temp >= constants.acsDefaultComfort &&
                    temp < constants.acsHotTemp
                )
                    return "warmBackground";
                else return "hotBackground";
            } else if (zone.type === constants.zoneTypes.floor) {
                if (temp >= constants.ranges.thermostat.floor.min && temp < 19)
                    return "ecoBackground";
                else if (temp >= 19 && temp <= 24) return "warmBackground";
                else return "hotBackground";
            } else {
                if (temp >= constants.defaultEco && temp < constants.defaultComfort)
                    return "ecoBackground";
                else if (temp >= constants.defaultComfort && temp < constants.hotTemp)
                    return "warmBackground";
                else return "hotBackground";
            }
        },
        getDeviceTemperatureColorBackground: function (device, schedule) {
            if (!device.data.power) return "offBackground";
            if (device.data.mode === "auto") {
                let tz = timezones.default.find(
                    (tz) => tz.value === this.installation.timeZoneId
                );
                if (!tz) {
                    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    timezones.default.every((ti) => {
                        let myUtc = ti.utc.find((utc) => utc === timezone);
                        if (myUtc) {
                            tz = ti;
                            return false;
                        }
                        return true;
                    });
                }
                let date = moment.utc().tz(tz.utc[0]);
                let currentDay = date.day() > 0 ? date.day() - 1 : 6;
                let currentHour = date.hour();

                let scheduleStatus = schedule[currentDay].charAt(currentHour);

                switch (scheduleStatus) {
                    case "O":
                        return device.data.ice_mode ? "coldBackground" : "offBackground";
                    case "C":
                        return "warmBackground";
                    case "E":
                        return "ecoBackground";
                }
            }

            let iceModeTemp = null;
            switch (device.data.type) {
                case constants.deviceTypes.acs:
                    iceModeTemp = constants.acsIceModeTemp;
                    break;

                case constants.zoneTypes.oval_towel:
                case constants.deviceTypes.radiatorb:
                case constants.deviceTypes.radiator:
                case constants.deviceTypes.towel:
                case constants.deviceTypes.therm:
                    iceModeTemp = constants.iceModeTemp;
                    break;
                case constants.deviceTypes.floor:
                    iceModeTemp = -1;
                    break;
                default:
                    iceModeTemp = constants.iceModeTemp;
            }

            let temp = device.data.temp;
            if (temp === iceModeTemp) {
                return "coldBackground";
            } else if (device.data.type === constants.zoneTypes.acs) {
                if (
                    temp >= constants.acsDefaultEco &&
                    temp < constants.acsDefaultComfort
                ) {
                    return "ecoBackground";
                } else if (
                    temp >= constants.acsDefaultComfort &&
                    temp < constants.acsHotTemp
                ) {
                    return "warmBackground";
                } else {
                    return "hotBackground";
                }
            } else if (device.data.type === constants.zoneTypes.floor) {
                if (temp >= constants.ranges.thermostat.floor.min && temp < 19) {
                    return "ecoBackground";
                } else if (temp >= 19 && temp <= 24) {
                    return "warmBackground";
                } else {
                    return "hotBackground";
                }
            } else {
                if (temp >= constants.defaultEco && temp < constants.defaultComfort) {
                    return "ecoBackground";
                } else if (
                    temp >= constants.defaultComfort &&
                    temp < constants.hotTemp
                ) {
                    return "warmBackground";
                } else {
                    return "hotBackground";
                }
            }
        },

        getZoneFinalInconsistency: function (zone) {
            let className = this.getZoneTemperatureColorBackground(zone);

            Object.values(this.devices).forEach((d) => {
                if (zone.mode === "auto") {
                    if (zone.mode !== d.data.mode) className = "";
                } else {
                    if (d.data.temp !== zone.temp) className = "";
                }
            });

            return className;
        },
    },
};
